export default __webpack_public_path__ + "static/DF_2021-27433b1c0d5675aa7a7d21a6a4d5711d.pdf";